export default function Contact() {
  return (
    <section id="contact" className="bg-white py-36">
      <div className="max-w-4xl mx-auto px-8 lg:px-16">
        <div className="text-center">
          <h2 className="text-4xl lg:text-5xl font-bold text-[#1A2B4A] mb-6">
            Strategic Partnerships & Inquiries
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto mb-12">
            For institutional partnerships and capital discussions:
          </p>

          <div className="space-y-4 mb-8">
            <p className="text-lg text-gray-700">
              <a href="mailto:admin@fluxpointdigital.org" className="hover:text-[#1A2B4A] transition-colors cursor-pointer">
                admin@fluxpointdigital.org
              </a>
            </p>
            <p className="text-lg text-gray-700">
              <a href="tel:+19094522539" className="hover:text-[#1A2B4A] transition-colors cursor-pointer">
                +1 (909) 452-2539
              </a>
            </p>
          </div>

          <a
            href="mailto:admin@fluxpointdigital.org?subject=Consultation Request"
            className="inline-block px-16 py-4 bg-[#1A2B4A] text-white rounded-lg text-base font-medium hover:bg-[#0f1a2e] hover:scale-105 hover:shadow-lg transition-all duration-300 shadow-md cursor-pointer whitespace-nowrap"
          >
            Schedule a Strategic Consultation
          </a>
        </div>
      </div>
    </section>
  );
}